module.exports = __webpack_public_path__ + "static/media/mediation.e26df186.svg";